import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ClearViewPage from '../ClearViewPage';
import { fetchParentStudents } from '../../services/api';

export default function ProgressAndPride() {
  const { studentId, classId } = useParams();
  const location = useLocation();
  const stateStudent = location.state?.student;
  const initialName = stateStudent
    ? `${stateStudent.first_name || ''} ${stateStudent.last_name || ''}`.trim()
    : '';

  const [studentName, setStudentName] = useState(initialName);

  useEffect(() => {
    if (initialName || !studentId) return;

    let mounted = true;
    fetchParentStudents()
      .then((data) => {
        if (!mounted || !data?.students) return;
        const match = data.students.find((student) => String(student.student_id) === String(studentId));
        if (match) {
          const name = `${match.first_name || ''} ${match.last_name || ''}`.trim();
          if (name) setStudentName(name);
        }
      })
      .catch(() => {
        // silently ignore; fallback will remain to Child #ID
      });

    return () => {
      mounted = false;
    };
  }, [initialName, studentId]);

  return (
    <ClearViewPage
      studentId={studentId}
      classId={classId}
      studentName={studentName}
      role="parent"
    />
  );
}
